import axios from './client';

export const createBlog = async (data) => {
  const response = await axios.post('/blogs', data);
  return response.data;
};

export const getBlogs = async (page = 1, limit = 10) => {
  const response = await axios.get(`/blogs?page=${page}&limit=${limit}`);
  return response.data;
};

export const getBlogById = async (id) => {
  const response = await axios.get(`/blogs/${id}`);
  return response.data;
};

export const updateBlog = async (id, data) => {
    const response = await axios.put(`/blogs/${id}`, data);
    return response.data;
};
export const deleteBlog = async (id) => {
    const response = await axios.delete(`/blogs/${id}`);
    return response.data;
};

export const toggleLike = async (id) => {
    const response = await axios.post(`/blogs/${id}/like`);
    return response.data;
};

export const addComment = async (id, content) => {
    const response = await axios.post(`/blogs/${id}/comment`, { content });
    return response.data;
};

export const deleteComment = async (commentId) => {
    const response = await axios.delete(`/blogs/comment/${commentId}`);
    return response.data;
};

export const getAdminBlogStats = async () => {
    const response = await axios.get('/blogs/analytics/all');
    return response.data;
};

export const getBlogDetailStats = async (id) => {
    const response = await axios.get(`/blogs/analytics/${id}`);
    return response.data;
};
